/* Future Form - motion and interaction layer (draft theme).
   Everything here is progressive: without it the page is complete.
   Honors prefers-reduced-motion and only adds pointer effects on devices
   with a mouse or trackpad. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var root = document.documentElement;
  if (!reduce) root.classList.add('ffx');

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ---------- one shared scroll loop ---------- */
  var jobs = [];
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < jobs.length; i++) jobs[i](vh);
  }
  function request() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
  }
  function onScroll(fn) { jobs.push(fn); request(); }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);

  /* ---------- page progress line ---------- */
  function initProgress() {
    if (reduce || document.querySelector('.ffx-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'ffx-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    onScroll(function (vh) {
      var h = root.scrollHeight - vh;
      bar.style.transform = 'scaleX(' + (h > 0 ? clamp(window.pageYOffset / h, 0, 1) : 0).toFixed(4) + ')';
    });
  }

  /* ---------- hero: frame shrinks into a card as you scroll ---------- */
  function initHero() {
    if (reduce) return;
    document.querySelectorAll('.ff-hero, .ffx-hero').forEach(function (h) {
      if (h.dataset.ffx) return;
      h.dataset.ffx = '1';
      onScroll(function () {
        var r = h.getBoundingClientRect();
        var p = clamp(-r.top / (r.height * 0.9), 0, 1);
        h.style.setProperty('--hp', p.toFixed(4));
      });
    });
  }

  /* ---------- headings rise word by word ---------- */
  function split(el) {
    if (el.dataset.ffxSplit) return;
    for (var i = 0; i < el.childNodes.length; i++) {
      if (el.childNodes[i].nodeType !== 3) return;
    }
    var txt = el.textContent.trim();
    if (!txt) return;
    el.dataset.ffxSplit = '1';
    var wasIn = el.classList.contains('is-in');
    el.classList.remove('is-in');
    el.setAttribute('aria-label', txt);
    var words = txt.split(/\s+/);
    el.textContent = '';
    words.forEach(function (w, n) {
      var m = document.createElement('span');
      m.className = 'ffx-wm';
      m.setAttribute('aria-hidden', 'true');
      var s = document.createElement('span');
      s.className = 'ffx-wd';
      s.style.setProperty('--i', n);
      s.textContent = w;
      m.appendChild(s);
      el.appendChild(m);
      if (n < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    el.classList.add('ffx-split');
    if (wasIn) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { el.classList.add('is-in'); });
      });
    }
  }
  function initSplit(scope) {
    if (reduce) return;
    (scope || document).querySelectorAll('.ff-hero h1, .ffx-hero h1, .ff-pdp__h1, .ff h2.ff-d1[data-ff-reveal], .ff h2.ff-d2[data-ff-reveal], .ff h2.ff-d3[data-ff-reveal]').forEach(split);
  }

  /* ---------- pointer: spotlight, tilt, magnetic buttons ---------- */
  var GLOW = '.ff-cat, .ff-card__media, .ff-ben, .ff-rev, .ffx-hero__frame';
  function initPointer() {
    if (!fine || reduce || root.dataset.ffxPointer) return;
    root.dataset.ffxPointer = '1';
    document.addEventListener('pointermove', function (e) {
      var t = e.target.closest && e.target.closest(GLOW);
      if (!t) return;
      var r = t.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top) / r.height;
      t.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
      t.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      if (t.classList.contains('ff-cat') || t.classList.contains('ffx-hero__frame')) {
        t.style.setProperty('--ry', ((x - 0.5) * 7).toFixed(2) + 'deg');
        t.style.setProperty('--rx', ((0.5 - y) * 7).toFixed(2) + 'deg');
      }
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var t = e.target.closest && e.target.closest('.ff-cat, .ffx-hero__frame');
      if (t && !t.contains(e.relatedTarget)) {
        t.style.setProperty('--rx', '0deg');
        t.style.setProperty('--ry', '0deg');
      }
    });
  }
  function initMagnetic(scope) {
    if (!fine || reduce) return;
    (scope || document).querySelectorAll('.ff-hero .ff-btn, .ffx-hero .ff-btn, .ff-cta .ff-btn, .ffx-st .ff-btn').forEach(function (b) {
      if (b.dataset.ffxMag) return;
      b.dataset.ffxMag = '1';
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        b.style.transform = 'translate(' + clamp(dx * 0.18, -8, 8).toFixed(1) + 'px,' + clamp(dy * 0.3, -6, 6).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- image parallax inside framed media ---------- */
  function initParallax(scope) {
    if (reduce) return;
    (scope || document).querySelectorAll('.ff-show__media .ff-media, .ff-cta__bg, .ff-vband__bg').forEach(function (m) {
      if (m.dataset.ffx) return;
      m.dataset.ffx = '1';
      m.classList.add('ffx-par');
      onScroll(function (vh) {
        var r = m.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var c = (r.top + r.height / 2 - vh / 2) / vh;
        m.style.setProperty('--py', (c * -48).toFixed(1) + 'px');
      });
    });
  }

  /* ---------- pinned story ---------- */
  function initStory(scope) {
    (scope || document).querySelectorAll('[data-ffx-story]').forEach(function (s) {
      if (s.dataset.ffx) return;
      s.dataset.ffx = '1';
      var frames = s.querySelectorAll('.ffx-story__frame');
      var steps = s.querySelectorAll('.ffx-story__step');
      var dots = s.querySelectorAll('.ffx-story__dot');
      function set(i) {
        [frames, steps, dots].forEach(function (list) {
          list.forEach(function (n, j) { n.classList.toggle('is-on', j === i); });
        });
        dots.forEach(function (d, j) {
          if (j === i) d.setAttribute('aria-current', 'step'); else d.removeAttribute('aria-current');
        });
      }
      s._i = 0;
      set(0);
      onScroll(function (vh) {
        var best = 0;
        var bd = Infinity;
        steps.forEach(function (st, j) {
          var r = st.getBoundingClientRect();
          var d = Math.abs(r.top + r.height / 2 - vh / 2);
          if (d < bd) { bd = d; best = j; }
        });
        if (s._i !== best) { s._i = best; set(best); }
        var r = s.getBoundingClientRect();
        var span = r.height - vh;
        s.style.setProperty('--sp', (span > 0 ? clamp(-r.top / span, 0, 1) : 0).toFixed(4));
      });
      dots.forEach(function (d, j) {
        d.addEventListener('click', function () {
          var st = steps[j];
          if (!st) return;
          var top = window.pageYOffset + st.getBoundingClientRect().top - (window.innerHeight - st.offsetHeight) / 2;
          window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ---------- statement: words light up as you read ---------- */
  function initStatement(scope) {
    (scope || document).querySelectorAll('[data-ffx-statement]').forEach(function (s) {
      if (s.dataset.ffx) return;
      s.dataset.ffx = '1';
      var words = s.querySelectorAll('.ffx-st__w');
      var text = s.querySelector('.ffx-st__text');
      s.querySelectorAll('.ffx-st__w--accent').forEach(function (w, i) { w.classList.add('ffx-acc-' + (i % 3)); });
      var n = words.length;
      if (reduce || !text) {
        words.forEach(function (w) { w.classList.add('is-lit'); });
        return;
      }
      var last = -1;
      onScroll(function (vh) {
        var r = text.getBoundingClientRect();
        var p = clamp((vh * 0.82 - r.top) / (r.height + vh * 0.3), 0, 1);
        var k = Math.round(p * n);
        if (k === last) return;
        last = k;
        for (var i = 0; i < n; i++) words[i].classList.toggle('is-lit', i < k);
      });
    });
  }

  /* ---------- drag to scroll product rails with a mouse ---------- */
  function initDrag(scope) {
    if (!fine) return;
    (scope || document).querySelectorAll('[data-ff-rail-track], .ff-scroller').forEach(function (t) {
      if (t.dataset.ffxDrag) return;
      t.dataset.ffxDrag = '1';
      var down = false, moved = false, sx = 0, sl = 0;
      t.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; sx = e.clientX; sl = t.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 6) {
          if (!moved) { moved = true; t.classList.add('is-drag'); }
          t.scrollLeft = sl - dx;
        }
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        if (moved) t.classList.remove('is-drag');
      });
      t.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      t.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- LED field: each dot is one diode ---------- */
  function ledField(cv, opt) {
    opt = opt || {};
    var dim = opt.dim || 1;
    var light = !!opt.light;
    var HUES = [[224, 36, 58], [232, 117, 42], [47, 143, 216]];
    var hue = HUES[0], hueIdx = -1;
    var modes = opt.modes ? opt.modes.querySelectorAll('.ffx-mode') : [];
    function setHue(t) {
      var lock = host.getAttribute('data-ffx-lock');
      if (lock !== null && HUES[+lock]) {
        hue = HUES[+lock];
        host.style.setProperty('--ffx-hue', 'rgb(' + hue.join(',') + ')');
        return;
      }
      if (!opt.cycle || reduce) { hue = HUES[0]; return; }
      var period = 5.5, f = (t / period) % HUES.length;
      var a = Math.floor(f), b = (a + 1) % HUES.length;
      var k = f - a; k = k < 0.7 ? 0 : (k - 0.7) / 0.3; k = k * k * (3 - 2 * k);
      hue = [0, 1, 2].map(function (c) { return Math.round(HUES[a][c] + (HUES[b][c] - HUES[a][c]) * k); });
      var idx = k < 0.5 ? a : b;
      if (idx !== hueIdx) {
        hueIdx = idx;
        modes.forEach(function (m, j) { m.classList.toggle('is-on', j === idx); });
      }
      host.style.setProperty('--ffx-hue', 'rgb(' + hue.join(',') + ')');
    }
    var ctx = cv.getContext && cv.getContext('2d');
    if (!ctx) return;
    var host = cv.parentElement;
    var W = 0, H = 0, pts = null, cx = 0, cy = 0, maxD = 1;
    var t0 = 0, raf = 0, visible = false;
    var px = 0, py = 0, sx = 0, sy = 0, lastMove = -1e9;

    function size() {
      var r = host.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = Math.max(1, r.width); H = Math.max(1, r.height);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var gap = W < 750 ? 13 : 16;
      var cols = Math.ceil(W / gap) + 1, rows = Math.ceil(H / gap) + 1;
      cx = W * (opt.cx || 0.68); cy = H * 0.5;
      maxD = Math.sqrt(W * W + H * H);
      pts = new Float32Array(cols * rows * 4);
      var i = 0;
      for (var y = 0; y < rows; y++) {
        for (var x = 0; x < cols; x++) {
          var X = x * gap + gap / 2, Y = y * gap + gap / 2;
          pts[i++] = X; pts[i++] = Y; pts[i++] = Math.random() * 6.283;
          pts[i++] = Math.sqrt((X - cx) * (X - cx) + (Y - cy) * (Y - cy));
        }
      }
      if (!sx) { sx = cx; sy = cy; }
      if (reduce || !visible) draw(performance.now());
    }

    function draw(now) {
      if (!t0) t0 = now;
      var t = (now - t0) / 1000;
      ctx.clearRect(0, 0, W, H);
      var lx, ly;
      if (now - lastMove < 3500) { lx = px; ly = py; }
      else { lx = W * (0.62 + 0.24 * Math.sin(t * 0.21)); ly = H * (0.5 + 0.3 * Math.sin(t * 0.29 + 1.3)); }
      if (reduce) { lx = cx; ly = cy; sx = lx; sy = ly; }
      sx += (lx - sx) * 0.07; sy += (ly - sy) * 0.07;
      var R = Math.max(W, H) * 0.3;
      setHue(t);
      var hs = hue.join(',');
      var hot = 'rgb(' + hue.map(function (c) { return Math.min(255, c + 40); }).join(',') + ')';

      var g = ctx.createRadialGradient(sx, sy, 0, sx, sy, R * 1.5);
      g.addColorStop(0, 'rgba(' + hs + ',' + ((light ? 0.13 : 0.26) * dim).toFixed(3) + ')');
      g.addColorStop(1, 'rgba(' + hs + ',0)');
      ctx.globalAlpha = 1;
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, W, H);

      var front = reduce ? 1e9 : Math.max(0, t - 0.1) * maxD * 0.55;
      for (var i = 0; i < pts.length; i += 4) {
        var on = (front - pts[i + 3]) / 140;
        if (on <= 0) continue;
        if (on > 1) on = 1;
        var dx = pts[i] - sx, dy = pts[i + 1] - sy;
        var d = Math.sqrt(dx * dx + dy * dy);
        var b = d < R ? 1 - d / R : 0;
        b = b * b;
        var a = ((light ? 0.11 : 0.09) + (reduce ? 0 : 0.045 * Math.sin(t * 1.6 + pts[i + 2])) + b * (light ? 0.75 : 0.9)) * on * dim;
        if (a < 0.03) continue;
        var s = 1.3 + b * 1.9;
        ctx.globalAlpha = a > 1 ? 1 : a;
        ctx.fillStyle = light ? (b > 0.12 ? 'rgb(' + hs + ')' : '#1D1D1F') : (b > 0.45 ? hot : 'rgb(' + hs + ')');
        ctx.fillRect(pts[i] - s / 2, pts[i + 1] - s / 2, s, s);
      }
      ctx.globalAlpha = 1;
    }

    function loop(now) {
      raf = 0;
      if (!visible || document.hidden) return;
      draw(now);
      raf = window.requestAnimationFrame(loop);
    }
    function start() { if (!raf && !reduce) raf = window.requestAnimationFrame(loop); }

    if ('ResizeObserver' in window) new ResizeObserver(size).observe(host);
    else window.addEventListener('resize', size);
    size();

    if (reduce) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) start();
      }).observe(host);
    } else { visible = true; start(); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
    if (fine) {
      host.addEventListener('pointermove', function (e) {
        var r = host.getBoundingClientRect();
        px = e.clientX - r.left; py = e.clientY - r.top; lastMove = performance.now();
      }, { passive: true });
    }
  }
  function initLed(scope) {
    (scope || document).querySelectorAll('[data-ffx-led]').forEach(function (cv) {
      if (cv.dataset.ffx) return;
      cv.dataset.ffx = '1';
      var hero = cv.closest('.ffx-hero');
      ledField(cv, { light: !!(hero && hero.classList.contains('ffx-hero--light')), cycle: true, modes: hero && hero.querySelector('[data-ffx-modes]') });
    });
    (scope || document).querySelectorAll('.ff-cta').forEach(function (sec) {
      if (sec.querySelector('.ffx-led')) return;
      var c = document.createElement('canvas');
      c.className = 'ffx-led ffx-led--cta';
      c.setAttribute('aria-hidden', 'true');
      c.dataset.ffx = '1';
      sec.insertBefore(c, sec.firstChild);
      ledField(c, { dim: 0.8, cx: 0.5, light: true, cycle: true });
    });
  }

  /* ---------- product pages ---------- */
  function techOf(title) {
    var t = (title || '').toLowerCase();
    if (/\bcryo|\bcold\b|\bice\b|\bfreez/.test(t)) return 'cold';
    if (/sauna|\bpods?\b|\bheat\b|\bsteam\b|far-infrared|far infrared/.test(t)) return 'heat';
    return 'light';
  }
  function initPdp(scope) {
    var pdp = (scope || document).querySelector('.ff-pdp');
    if (!pdp || pdp.dataset.ffx) return;
    pdp.dataset.ffx = '1';
    var h1 = pdp.querySelector('.ff-pdp__h1');
    var sec = pdp.closest('section') || pdp;
    sec.classList.add('ffx-pdp', 'ffx-tech--' + techOf(h1 && h1.textContent));

    /* gallery: soft glow, image eases in, zoom where you point */
    var gal = pdp.querySelector('.ff-pdp__gal');
    var main = pdp.querySelector('.ff-pdp__main');
    if (gal && !gal.querySelector('.ffx-aura')) {
      var aura = document.createElement('div');
      aura.className = 'ffx-aura';
      aura.setAttribute('aria-hidden', 'true');
      gal.insertBefore(aura, gal.firstChild);
    }
    var img = main && main.querySelector(':scope > img');
    if (img && !reduce) {
      var play = function () {
        img.classList.remove('ffx-swap');
        void img.offsetWidth;
        img.classList.add('ffx-swap');
      };
      play();
      new MutationObserver(function (ms) {
        if (ms.some(function (m) { return m.attributeName === 'src' || m.attributeName === 'srcset'; })) play();
      }).observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
      if (fine) {
        main.addEventListener('pointermove', function (e) {
          if (e.target.closest('button')) { main.classList.remove('is-zoom'); return; }
          var r = main.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
          main.classList.add('is-zoom');
        });
        main.addEventListener('pointerleave', function () { main.classList.remove('is-zoom'); });
      }
    }
    pdp.querySelectorAll('.ff-pdp__thumb').forEach(function (t, i) {
      t.classList.add('ffx-stg');
      t.style.setProperty('--i', Math.min(i, 10));
    });

    /* buy panel builds in, one block after another */
    var buy = pdp.querySelector('.ff-pdp__buy');
    if (buy) {
      Array.prototype.forEach.call(buy.children, function (c, i) {
        c.classList.add('ffx-stg');
        c.style.setProperty('--i', Math.min(i, 12));
      });
      buy.querySelectorAll('.ff-hl > li').forEach(function (li, i) {
        li.classList.add('ffx-stg');
        li.style.setProperty('--i', i + 4);
      });
    }
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { pdp.classList.add('ffx-go'); });
    });
  }

  /* ---------- sections below the product: rise in as they arrive ---------- */
  function initRise(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (!document.querySelector('.ff-pdp')) return;
    var secs = (scope || document).querySelectorAll('#MainContent > .shopify-section');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-up');
        io.unobserve(e.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(secs, function (s, n) {
      if (n === 0 || s.dataset.ffxRise) return;
      s.dataset.ffxRise = '1';
      var wrap = s.querySelector('.ff__wrap');
      if (!wrap) return;
      Array.prototype.forEach.call(wrap.children, function (c) {
        if (c.hasAttribute('data-ff-reveal') || c.offsetHeight === 0) return;
        var kids = c.children;
        var grid = kids.length >= 3 && /grid|flex/.test(getComputedStyle(c).display);
        if (grid) {
          Array.prototype.forEach.call(kids, function (k, i) {
            k.classList.add('ffx-rise');
            k.style.setProperty('--i', Math.min(i, 8));
            io.observe(k);
          });
        } else {
          c.classList.add('ffx-rise');
          io.observe(c);
        }
      });
    });
  }

  function boot(scope) {
    initProgress();
    initHero();
    initSplit(scope);
    initPointer();
    initMagnetic(scope);
    initParallax(scope);
    initStory(scope);
    initStatement(scope);
    initDrag(scope);
    initLed(scope);
    initPdp(scope);
    initRise(scope);
    request();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
